export const globalNavHostCommand = "GlobalNavHostCommand";
export const globalNavRemoteEvent = "GlobalNavRemoteEvent";
export const notificationsHostCommand = "NotificationsHostCommand";
export const notificationsRemoteEvent = "NotificationsRemoteEvent";
